import LegalDocument from '../components/LegalDocument';
import { privacyPolicyLines } from '../data/legalDocuments';

const PrivacyPolicy = () => <LegalDocument lines={privacyPolicyLines} />;

export default PrivacyPolicy;
